import React, { useState, useEffect } from 'react';
import { googleLogout, useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import dayjs from 'dayjs';
import './App.css';
import pplogo from './static/pplogo.png';
import playboy from './static/playboy.jpeg';

function App() {
    const [user, setUser] = useState(undefined);
    const [profile, setProfile] = useState(undefined);
    const [status, setStatus] = useState([]);
    const [loading, setLoading] = useState(false);

    const appendtoStatus = (text) => {
        const dateString = dayjs().format('HH:mm:ss');
        setStatus(prevStatusArray => [...prevStatusArray, dateString + ' ' + text]);
    }

    const api_host = 'https://api.puhurinpojat.com';

    const login = useGoogleLogin({
        onSuccess: (codeResponse) => {
            setUser(codeResponse);
        },
        onError: (error) => {
            console.log('Login Failed:', error);
            setStatus(['Kirjautuminen epäonnistui. Yritä uudelleen.']);
        }
    });

    useEffect(() => {
        if (user) {
            axios
                .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`, {
                    headers: { Accept: 'application/json' }
                })
                .then((res) => setProfile(res.data))
                .catch((err) => console.log(err));
        }
    }, [user]);

    const logOut = () => {
        googleLogout();
        setProfile(null);
        setStatus([]);
        setLoading(false);
    };

    const handleOpenGate = async () => {
        if (window.confirm('Oletko varma? Portti aukeaa ihan oikeasti')) {
            setLoading(true);
            setStatus([]);
            var id = await openGate(user.access_token);
            appendtoStatus('Pyynnön id: ' + id);
            pollStatus(user.access_token, id);
        }
    };

    const openGate = async (token) => {
        return axios.post(api_host + '/gate/open', {}, { headers: { 'Authorization': token } })
            .then((res) => {
                appendtoStatus('Portin avaus aloitettu, odota hetki...');
                return res.data.id;
            }).catch((error) => {
                console.error('Error opening gate:', error);
                appendtoStatus('Virhe portin avauksessa 😕: ' + error);
                setLoading(false);
            });
    };

    const pollStatus = (token, id) => {
        axios.get(api_host + '/gate/status/' + id, { headers: { 'Authorization': token } })
            .then((res) => {
                if (res.data.status === 'busy' || res.data.status === 'completed') {
                    appendtoStatus('Portti aukeaa! 🎉');
                    setLoading(false);
                } else if (res.data.status === 'no-answer' || res.data.status === 'canceled' || res.data.status === 'failed') {
                    appendtoStatus('Portin avaaminen epäonnistui 😕, syy: ' + res.data.status);
                    setLoading(false);
                } else {
                    appendtoStatus('Avaaminen vielä kesken, tilanne: ' + res.data.status);
                    setTimeout(pollStatus, 2000, token, id);
                }
            }).catch((error) => {
                console.error('Error polling status:', error);
                appendtoStatus('Virhe statuksen haussa: ' + error);
                setLoading(false);
            });
    };

    return (
        <div className="app-bg">
            <div className="card">
                <div className="card-header">
                    <a href="https://puhurinpojat.fi">
                        <img src={pplogo} className="card-logo" alt="PP logo" />
                    </a>
                    <h1 className="card-title">PP Portinavaus</h1>
                </div>

                {user && profile ? (
                    <>
                        <div className="user-row">
                            <img className="user-avatar" src={profile.picture} alt="user" />
                            <span className="user-name">Moro, {profile.name}</span>
                        </div>

                        <div className="actions">
                            <button
                                className="btn-gate"
                                onClick={handleOpenGate}
                                disabled={loading}
                            >
                                {loading ? <span className="spinner" /> : 'Avaa portti'}
                            </button>

                            <button className="btn-logout" onClick={logOut} disabled={loading}>
                                Kirjaudu ulos
                            </button>
                        </div>

                        {status.length > 0 && (
                            <div className="status-log">
                                <span className="status-label">Loki</span>
                                <ul className="status-list">
                                    {status.map((s, i) => (
                                        <li key={i} className="status-item">
                                            <span className="status-dot" />
                                            <span className="status-text">{s}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </>
                ) : (
                    <button className="btn-gate" onClick={login}>
                        Kirjaudu PP:n tunnuksella
                    </button>
                )}

                <div className="card-footer">
                    <a href="https://fi.glosbe.com/et/fi/j%C3%A4nku">
                        <img src={playboy} className="footer-logo" alt="playboy" />
                    </a>
                </div>
            </div>
        </div>
    );
}

export default App;
